import React, { useState } from 'react';

// このコンポーネントが受け取るプロパティの型定義
interface MessageInputProps {
  onSendMessage: (message: string) => void;  // メッセージ送信時に呼ばれる関数
  disabled?: boolean;      // 入力を無効にするかどうか（オプション）
  placeholder?: string;    // プレースホルダーテキスト（オプション）
}

const MessageInput: React.FC<MessageInputProps> = ({ 
  onSendMessage, 
  disabled = false,
  placeholder = "メッセージを入力してください..."
}) => {
  // useState: 入力中のメッセージを管理するState
  const [inputMessage, setInputMessage] = useState('');

  // フォーム送信時の処理
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault(); // ページリロードを防ぐ
    
    // 空文字でない場合のみ送信
    if (inputMessage.trim()) {
      onSendMessage(inputMessage.trim()); // 親コンポーネントに送信
      setInputMessage(''); // 入力欄をクリア
    }
  };

  return (
    <form onSubmit={handleSubmit} className="message-input-form">
      <div className="input-container">
        <input
          type="text"
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)} // 入力値の変更を監視
          placeholder={placeholder}
          disabled={disabled}
          className="message-input"
        />
        <button 
          type="submit" 
          disabled={disabled || !inputMessage.trim()}
          className="send-button"
        >
          {disabled ? '送信中...' : '送信'}
        </button>
      </div>
    </form>
  );
};

export default MessageInput;
